export default __webpack_public_path__ + "static/media/store-front.fb04f4d3.svg";